export const SheetType = {
  NewMaster: "NewMaster",
  Rewrite: "Rewrite",
  ScheduleToTheMaster: "ScheduleToTheMaster",
  RewriteNewMasterDocument: "RewriteNewMasterDocument",
};
